import { Form, Input } from "decorator-form";
import InputType from "common/form/InputType";
import { IMenuPage } from "common/form/fields/PageField";
@Form({ title: "Check out config" })
export default class CourseCheckoutConfig {

    @Input({ type: InputType.PAGE, title: "Redirect Page on Successful payment" })
    public redirectSuccess?: IMenuPage;

    public value? :any
}



// WEBPACK FOOTER //
// ./src/panels/checkout/CourseCheckout.ts